/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import memberClient from 'member-api';

const RESOURCE_ROOT_ADDRESSSERVICE = 'addressbook';
const RESOURCE_VERSION_ADDRESS = '/v2';
const RESOURCE_PAGE_ADDRESSSERVICE = '/contacts';
const RESOURCE_PAGE_ACTION = '/billingaddress';

// /r/api/addressbook/v2/contacts/billingaddress/{contactId}

const getBillingUserAddressBook = ({
    wcEnv, contactId, jwtToken,
}) => {
    const params = {};
    const resourcePage = `${RESOURCE_ROOT_ADDRESSSERVICE}${RESOURCE_VERSION_ADDRESS}${RESOURCE_PAGE_ADDRESSSERVICE}${RESOURCE_PAGE_ACTION}/${contactId}`;
    return memberClient.performGet(wcEnv, resourcePage, jwtToken, params)
        .then((response) => response);
};

export default getBillingUserAddressBook;
